import { flatten } from 'lodash';
import { SupplierResponseInterface } from '../interfaces/survey.interface';

export class Suppliers {
  suppliers: SupplierResponseInterface[];
  constructor(suppliers: SupplierResponseInterface[]) {
    this.suppliers = suppliers;
  }

  listOfUniqueSuppliers() {
    return flatten(
      this.suppliers.map((supplier) => {
        return supplier.suppliers.map((supplierQ) => {
          return {
            id: supplierQ.id,
            quantity: supplier.quantity,
          };
        });
      })
    );
  }
}
